<template>
	<FilterComponent
		:title="'Propostas'"
		:open="openFilter"
		:fields="filterFields"
		@apply-filters="handleFilters"
		@update-open="openFilter = false"
    />
	<Commonlisting
		:listingData = "data"
		:headersData = "headers"
		:headerInfo = "headerInfo"
		:inputsListing= "inputs"
		:acoes-especiais="[{ campo: 'documento', nome_exibicao: 'Visualizar proposta em PDF' }]"
		:previous = "previous"
		:next = "next"
		:currentPage = "currentPage"
		:totalPages = "totalPages"
		:totalRecords = "totalRecords"
		:resetFormData= "resetFormData"
		:editFormData= "{}"
		:importFile= "false"
		:useForms= "false"
		:fileOnly= "true"
		:filterOnly="true"
		:customActions="[
			{ 	nome: 'Visualizar',
				field: 'id'
			},
		]"
		@previous-page= "pageData"
		@next-page= "pageData"
		@go-to-page= "goTo"
		@acao-customizada="tratarAcaoCustomizada"
		@filter="openFilter = true"
	/>

	<PropostasForm
		:open= "formOpen"
		:title= "'Proposta'"
		:resetFormData= "resetFormData"
		:proposta="proposta"
		@create-request = "solicitaoCreateUpdate"
		@create-response ="solicitaoCreateUpdate"
		@cancel-response-request="solicitacaoRemove"
		@proposta-file="sendPropostaDocumento"
		@send-notification="notifyEnvelope"
		@update-open= "formOpen = false"
	/>
	<CommonLoading
		v-if="loading"
	/>
</template>
<script>

import Commonlisting from '@/components/generalcomponents/CommonListing';
import EmpresasRepository from '@/services/EmpresasRepository.vue';
import { pageVariables } from '@/views/insideviews/propostas/PageVariablesPropostas';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import FilterComponent from "@/components/generalcomponents/CommonFilter.vue";
import Swal from "sweetalert2";
import PropostasForm from './PropostasForm.vue';
import CommonLoading from '@/components/generalcomponents/CommonLoading.vue';
import PropostasRepository from '@/services/PropostasRepository.vue';
import SolicitacoesRepository from '@/services/SolicitacoesRepository.vue';
import PropostaDcoumentosRepository from '@/services/PropostaDcoumentosRepository.vue';
import AssinaturaRepository from '@/services/AssinaturaRepository.vue';

export default {
	name: 'PropostasView',
	async created(){
		this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
		this.pageData(this.page)
	},
	data() {
		return {
			...pageVariables,
			data: [],
			previous: '',
			next: '',
			totalPages: 0,
			totalRecords: 0,
			currentPage: 0,
			resetFormData: false,
			onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
			proposta:{},
			openFilter: false,
			filters: [],
			formOpen : false,
			editOpen: false,
			editingId: '',
			loading: false,
			filterFields: []
		};
	},
	props: {
	},
	methods: {
		async pageData(page){
			this.loading = true; 
			const propostaRepo = new PropostasRepository();
			try {
				const response = await propostaRepo.getPropostas(this.onlineUser.token,page);
				if (response?.status  === 200) {
					this.data = response.data.data;
					this.totalPages = response.data.last_page;
					this.totalRecords = response.data.total;
					this.currentPage = response.data.current_page;

				if (response.data.next_page_url) {
					this.next = response.data.next_page_url;
				}else{
					this.next = ""
				}
				if (response.data.prev_page_url) {

					this.previous = response.data.prev_page_url;
				}else{
					this.previous = ""
				}
				this.loading = false; 

				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
			}
		},

		tratarAcaoCustomizada(payload) {
			const { nome, data } = payload;

			switch (nome) {
			case 'Visualizar':
				this.getEditData(data);
				break;

			case 'Editar':
				this.abrirModalEdicao(data);
				break;

			case 'Excluir':
				this.confirmarExclusao(data);
				break;

			default:
				console.warn(`Ação customizada não tratada: ${nome}`);
				break;
			}
		},
		async solicitaoCreateUpdate(data){
			this.loading = true; 
			const soliRepo = new SolicitacoesRepository();
			try {
				console.log(data)
				const response = await soliRepo.createSolicitacao(this.onlineUser.token,data);
				if (response?.status === 201 || response?.status === 200) {
					this.getEditData(this.editingId);
					this.resetForm();
					this.mostrarAlerta();
					this.loading = false; 
				} else {
					this.error = response?.message;
					this.mostrarAlertaErro(this.error);
					this.loading = false;
				}
			} catch (error) {
				handleUnauthorized(error);
				this.loading = false; 
			}	
		},
		async solicitacaoRemove(data){
			this.loading = true; 
			const soliRepo = new SolicitacoesRepository();
			try {
				console.log(data)
				const response = await soliRepo.deleteSolicitacao(this.onlineUser.token,data);
				if (response?.status === 200) {
					this.getEditData(this.editingId);
					this.resetForm();
					this.mostrarAlerta();
					this.loading = false; 
				} else {
					this.error = response?.message;
					this.mostrarAlertaErro(this.error);
					this.loading = false;
				}
			} catch (error) {
				handleUnauthorized(error);
				this.loading = false; 
			}	
		},
		async sendPropostaDocumento(data){
			this.loading = true; 
			const docRepo = new PropostaDcoumentosRepository();
			try {
				console.log(data)
				const response = await docRepo.createDocumento(this.onlineUser.token,data);
				if (response?.status === 201) {
					this.getEditData(this.editingId);
					this.resetForm();
					this.mostrarAlerta();
					this.loading = false; 
				} else {
					this.error = response?.message;
					this.mostrarAlertaErro(this.error);
					this.loading = false;
				}
			} catch (error) {
				handleUnauthorized(error);
				this.loading = false; 
			}	
		},
		async getEditData(id){
			this.loading = true; 
			const propostaRepo = new PropostasRepository();
			try {
				const response = await propostaRepo.getProposta(this.singularAccessPage,this.onlineUser.token,id);
				if (response?.status === 200) {
					this.proposta = response.data;
					this.formOpen = true;
					this.editingId = this.proposta.id;
					this.loading = false; 
				} else {
					this.loading = false; 
					this.error = response?.message;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
			}	
		},
		async sendImportFile(data){
			this.loading = true; 
			const empresasRepo = new EmpresasRepository();
			try {
				const response = await empresasRepo.importEmpresaFile(data,this.onlineUser.token,this.uploadDataPage);
				if (response?.status === 201) {
					this.loading = false; 
					this.mostrarAlerta();
				} else {
					this.loading = false; 
					this.mostrarAlertaErro(response?.message)
					this.error = response?.message;
				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
			}	
		},
		async notifyEnvelope(id){
			this.loading = true; 
			const signRepo = new AssinaturaRepository();
			try {
				const response = await signRepo.notify(this.onlineUser.token,id);
				if (response?.status === 200) {
					this.getEditData(this.editingId);
					this.loading = false; 
					this.mostrarAlerta();
				} else {
					this.loading = false; 
					this.mostrarAlertaErro(response?.message)
					this.error = response?.message;
				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
			}	
		},
		goTo(number){
			this.pageData(this.empresasGetPage+"?page="+number)
		},
		handleFilters(rawFilters){
			console.log(rawFilters)
			this.filters = rawFilters;
			this.openFilter = false;
			this.pageData(this.empresasGetPage);
		},
		resetForm() {
			this.resetFormData = true;
			this.$nextTick(() => {
				this.resetFormData = false;
			});
		},
		mostrarAlerta() {
			Swal.fire({
				icon: 'success',
				title: 'Sucesso!',
				text: 'A operação foi concluída com sucesso.',
				confirmButtonColor: '#3085d6', 
			});
		},
		mostrarAlertaErro(message) {
			Swal.fire({
				icon: 'error',
				title: 'Erro!',
				text: message,
				confirmButtonColor: '#3085d6', 
			});
		},
	},
	components:{
		Commonlisting,
		FilterComponent,
		PropostasForm,
		CommonLoading
	},
	setup() {
	return {
	}
	}}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
